export default function horizontalScrollOnMouseWheel(block, scrollSpeed) {
    block.addEventListener('wheel', function(event) {
        event.preventDefault();
        const delta = Math.sign(event.deltaY);
        block.scrollLeft += delta * scrollSpeed;
    });
}
